// UI-agnostic notification helpers
// Wrap notistack + i18n so feature layers never import UI directly

import { enqueueSnackbar } from 'notistack';
import i18next from 'i18next';

export function notifySuccess(i18nKeyOrMessage, options = {}) {
  try {
    const msg = i18next.exists(i18nKeyOrMessage) ? i18next.t(i18nKeyOrMessage) : i18nKeyOrMessage;
    enqueueSnackbar(msg, { variant: 'success', ...options });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[notifySuccess] failed:', e);
  }
}

export function notifyError(i18nKeyOrMessage, options = {}) {
  try {
    const msg = i18next.exists(i18nKeyOrMessage) ? i18next.t(i18nKeyOrMessage) : i18nKeyOrMessage;
    enqueueSnackbar(msg, { variant: 'error', ...options });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[notifyError] failed:', e);
  }
}
